import { render } from "./ProfitAndLossStructureChartById.vue?vue&type=template&id=532dc218&scoped=true"
import script from "./ProfitAndLossStructureChartById.vue?vue&type=script&lang=js"
export * from "./ProfitAndLossStructureChartById.vue?vue&type=script&lang=js"

import "./ProfitAndLossStructureChartById.vue?vue&type=style&index=0&id=532dc218&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532dc218"]])

export default __exports__